import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import YouTube from './components/YouTube/YouTube';
import Blog from './components/Blog/Blog';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import BackToTop from './components/BackToTop/BackToTop';
import './styles/global.css';

const Meta: React.FC = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';
  return (
    <Helmet>
      <html lang={language} />
      <title>Nuri Can Akturk — Senior Full Stack Developer</title>
      <meta
        name="description"
        content={
          isEn
            ? 'Senior Full Stack Software Developer based in Amsterdam. Building scalable web & mobile apps with React, Node.js, .NET, Unity3D and more.'
            : 'Amsterdam merkezli Kıdemli Full Stack Yazılım Geliştirici. React, Node.js, .NET, Unity3D ve daha fazlası ile ölçeklenebilir web ve mobil uygulamalar geliştiriyor.'
        }
      />
      <meta name="author" content="Nuri Can Akturk" />
      <meta property="og:title" content="Nuri Can Akturk — Senior Full Stack Developer" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://nuricanakturk.com" />
      <meta
        property="og:description"
        content="Senior Full Stack Software Developer based in Amsterdam, Netherlands."
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Nuri Can Akturk — Senior Full Stack Developer" />
      <link rel="canonical" href="https://nuricanakturk.com" />
    </Helmet>
  );
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <ThemeProvider>
          <Meta />
          <Navbar />
          <main>
            <Hero />
            <About />
            <Experience />
            <YouTube />
            <Blog />
            <Contact />
          </main>
          <Footer />
          <BackToTop />
        </ThemeProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
};

export default App;
